/**
 * sources
 * Asset manifest consumed by Resources.
 * Each entry: { name: string, type: 'gltfModel'|'texture'|'cubeTexture', path: string|string[] }
 */
export default [
    { name: 'candleModel', type: 'gltfModel', path: '/models/candle/candle.gltf' },

    { name: 'lid-01', type: 'gltfModel', path: '/models/lids/lid-01.gltf' },
    { name: 'lid-02', type: 'gltfModel', path: '/models/lids/lid-02.gltf' },
    { name: 'lid-03', type: 'gltfModel', path: '/models/lids/lid-03.gltf' },
    { name: 'lid-04', type: 'gltfModel', path: '/models/lids/lid-04.gltf' },
    { name: 'lid-05', type: 'gltfModel', path: '/models/lids/lid-05.gltf' },
    { name: 'lid-06', type: 'gltfModel', path: '/models/lids/lid-06.gltf' },
    { name: 'lid-07', type: 'gltfModel', path: '/models/lids/lid-07.gltf' },
    { name: 'lid-08', type: 'gltfModel', path: '/models/lids/lid-08.gltf' },
    { name: 'lid-09', type: 'gltfModel', path: '/models/lids/lid-09.gltf' },
    { name: 'lid-10', type: 'gltfModel', path: '/models/lids/lid-10.gltf' },
    { name: 'lid-11', type: 'gltfModel', path: '/models/lids/lid-11.gltf' },
    { name: 'lid-12', type: 'gltfModel', path: '/models/lids/lid-12.gltf' },
    { name: 'lid-13', type: 'gltfModel', path: '/models/lids/lid-13.gltf' },
    { name: 'lid-14', type: 'gltfModel', path: '/models/lids/lid-14.gltf' },
    { name: 'lid-15', type: 'gltfModel', path: '/models/lids/lid-15.gltf' },
]
